document.addEventListener('DOMContentLoaded', async () => {

  await autoRemoveServiceProduct();

  async function autoRemoveServiceProduct(){
    try {
      // 1. Get current cart state
      const response = await fetch('/cart.js');
      if (!response.ok) return;
      
      const cart = await response.json();
      if (!cart || !cart.items || cart.items.length === 0) return;

      // 2. Decide which items to remove
      var itemsToRemove = [];
      const warranty = cart.items.find(product => product.sku === 'ExtendedWarranty');
      if (warranty != undefined){
          const physicalProducts = cart.items.filter(product => product.requires_shipping == true);
          if(physicalProducts != undefined && physicalProducts.length == 0){
              itemsToRemove.push(warranty);
          }
      }
    
      if (itemsToRemove.length === 0) return;

      // 3. Prepare updates object (most efficient way — one request)
      const updates = {};
      cart.items.forEach((item, index) => {
        const line = index + 1; // Shopify lines are 1-based
        if (itemsToRemove.some(toRemove => toRemove.key === item.key || toRemove.variant_id === item.variant_id)) {       
          updates[item.key] = 0;
        }
      });

      // 4. Send the update (removes items by setting qty → 0)
      const updateRes = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      if (!updateRes.ok) {
        console.error('Cart update failed', await updateRes.text());
        return;
      }

      const updatedCart = await updateRes.json();

      // 5. Refresh UI (very important!)
      //    → many themes already listen to this
      if (window.location.pathname.includes('/cart')) {  
          window.location.reload();
      }
      document.dispatchEvent(new Event('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: updatedCart }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));   // Dawn / many themes
      document.dispatchEvent(new CustomEvent('cart:change', { detail: updatedCart }));

      // If your theme uses sections rendering:
      if (typeof Shopify?.theme?.sections?.cart?.refresh === 'function') {
        Shopify.theme.sections.cart.refresh();
      }    

      console.log(`Removed ${itemsToRemove.length} item(s) automatically`);
      
    } catch (err) {
      console.error('Auto-remove cart item error:', err);
    }
  }


});